import { ForstaProjectDto, ForstaProjectStatusDto } from "app/ApiClient";
import { LoadingState } from "types";

export interface ForstaProjectState {
  isForstaExportDialogOpened: boolean;
  exportLoading: LoadingState;
  getLatestLoading: LoadingState;
  getStatusLoading: LoadingState;
  updateLoading: LoadingState;
  errorMessage?: string;
  exportErrorMessage?: string;
  project: Nullable<ForstaProjectDto>;
  projectStatus: Nullable<ForstaProjectStatusDto>; 
}

export const initialForstaProjectState: ForstaProjectState = {
  isForstaExportDialogOpened: false,
  exportLoading: LoadingState.idle,
  getLatestLoading: LoadingState.idle,
  getStatusLoading: LoadingState.idle,
  updateLoading: LoadingState.idle,
  projectStatus: null,
  project: null,  
};
